import React, { FC } from 'react'
import { MedicationKnowledge } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Col, Row } from 'react-bootstrap'
import { buildExtSlices } from '../../../utils/helpers'
import { BooleanDisplay, CodeableConcept, StringDisplay } from '@teschglobal/tg-fhir-react-components'

interface Props {
    drug: MedicationKnowledge
}

const DrugSummary: FC<Props> = ({ drug }) => {
  const slices = buildExtSlices(drug?.extension as any, 'MedicationKnowledge')
  const fields = [
    {
      label: 'Drug Tier',
      value: slices.drugTierId?.[0],
      Component: CodeableConcept
    },
    {
      label: 'Step Therapy Limit',
      value: slices.stepTherapyLimit?.[0],
      Component: BooleanDisplay
    },
    {
      label: 'Prior Authorization',
      value: slices.priorAuthorization?.[0],
      Component: BooleanDisplay
    },
      {
      label: 'Plan ID',
      value: slices.planId?.[0],
      Component: StringDisplay
    },
    {
      label: 'Quantity Limit',
      value: slices.quantityLimit?.[0],
      Component: BooleanDisplay
    },
    {
      label: 'Mail Order',
      value: slices.mailOrder?.[0],
      Component: BooleanDisplay
    },
  ]

  return (
    <div>
      <Row className="mt-3 border border-secondary rounded p-3">
        <strong>{drug?.code?.text}</strong>
        {fields.map(({ label, value, Component }) => (
          <Col md={4} key={label}>
            <div className="d-flex gap-2">
              <strong>{label}:</strong>
              {value !== undefined && <Component data={value} />}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default DrugSummary
